import { Component, Fragment } from "react";
import { Redirect } from "react-router-dom";
import MetaTags from "react-meta-tags";

import UBXButton from "./../../components/ubx/button";

import { PageNotFoundMetaTitle, PageNotFoundMetaDescription } from "./../../config/meta";

import "./../../assets/css/containers/static/404.css";

export default class Error404 extends Component {
    constructor(props) {
        super(props);

        this.state = {
            redirect: false,
        };
    }

    redirect() {
        const { redirect } = this.state;

        const redirectPath = redirect instanceof Array ? redirect[0] : redirect;

        return redirect && <Redirect to={redirectPath} />;
    }

    render() {
        return (
            this.redirect() || (
                <Fragment>
                    <div id="page-not-found">
                        <div id="jheyms">
                            <p>Page not found.</p>
                            <UBXButton type="primary" block={true} onClick={(e) => this.setState({ redirect: "/" })}>
                                Back to home
                            </UBXButton>
                        </div>
                    </div>
                    <MetaTags>
                        <title>{PageNotFoundMetaTitle}</title>
                        <meta name="title" content={PageNotFoundMetaTitle} />
                        <meta name="description" content={PageNotFoundMetaDescription} />
                    </MetaTags>
                </Fragment>
            )
        );
    }
}
